//Here lies the standardized Firestore REST API schemas in which to do CRUD operations//
/*Entities:
1.User
2.Accident
3.Policy
*/

const userbyAccountIdQuerySchema = function(userAccountId){
  return {
  structuredQuery: {
    select: {
      fields: [
        {
          fieldPath: "email",
        },
        {
          fieldPath: "firstName",
        },
        {
          fieldPath: "lastName",
        },
        {
          fieldPath: "zipcode",
        },
        {
          fieldPath: "phone",
        },
        {
          fieldPath: "userId",
        },
        {
          fieldPath: "city",
        },
        {
          fieldPath: "state",
        },
        {
          fieldPath: "userCreationDate",
        },
      ],
    },
    from: [
      {
        collectionId: "users",
      },
    ],
    where: {
      fieldFilter: {
        field: {
          fieldPath: "userAccountId",
        },
        op: "EQUAL",
        value: {
          stringValue: userAccountId
        },
      },
    },
  }
}
};

const updatePolicyDocumentSchema = function(providerName,policyName,policyNumber, addressOnPolicy, agentName, agentPhone,  formattedArr ){
  return { fields: {
    "providerName":
    {"stringValue": providerName},
    "policyName":
    {"stringValue": policyName},
    "policyNumber":
    {"stringValue": policyNumber},
    "policyAddress":
    {"stringValue": addressOnPolicy},
    "agentName":
    {"stringValue": agentName},
    "agentPhone":
    {"stringValue": agentPhone},
   
    "vehicleList":
    {"arrayValue": {"values": formattedArr}},
    }
    }
};

const addUserDocumentSchema = function(firstName, lastName, phone, email, zipcode, city, state, username, userId, accountId, creationDate){
  return {
fields: {"firstName":
{"stringValue": firstName},
"lastName":
{"stringValue": lastName},
"phone":
{"stringValue": phone},
"email":
{"stringValue": email},
"zipcode":
{"stringValue": zipcode},
"city":
{"stringValue": city},
"state":
{"stringValue": state},
"username":
{"stringValue": username},
"userId":
{"stringValue": userId},
"userAccountId":
{"stringValue": accountId},
"userCreationDate":
{"stringValue": creationDate }
}
}
   
  
}



const addPolicyDocumentSchema = function(userId, policyId,providerName,policyName,policyNumber, addressOnPolicy, agentName, agentPhone, dateCreated, formattedArr ){
  return { fields: {
    "policyId":
  {"stringValue": policyId},
  "userId":
  {"stringValue": userId},
    "providerName":
    {"stringValue": providerName},
    "policyName":
    {"stringValue": policyName},
    "policyNumber":
    {"stringValue": policyNumber},
    "policyAddress":
    {"stringValue": addressOnPolicy},
    "agentName":
    {"stringValue": agentName},
    "agentPhone":
    {"stringValue": agentPhone},
    "dateCreated":
    {"stringValue": dateCreated},
    "vehicleList":
    {"arrayValue": {"values": formattedArr}},
    }
    
  }
   
  
}

const userQuerySchema = function(userId){return {
    structuredQuery: {
      select: {
        fields: [
          {
            fieldPath: "email",
          },
          {
            fieldPath: "firstName",
          },
          {
            fieldPath: "lastName",
          },
          {
            fieldPath: "zipcode",
          },
          {
            fieldPath: "phone",
          },
          {
            fieldPath: "userId",
          },
          {
            fieldPath: "city",
          },
          {
            fieldPath: "state",
          },
          {
            fieldPath: "userCreationDate",
          },
        ],
      },
      from: [
        {
          collectionId: "users",
        },
      ],
      where: {
        fieldFilter: {
          field: {
            fieldPath: "userId",
          },
          op: "EQUAL",
          value: {
            stringValue: userId,
          },
        },
      },
    }
  }
};

  const policyListQuerySchema = function(userId)  {return {
    "structuredQuery":
    {
    "select":
    {
  "fields": [
    {
    "fieldPath": "policyId"
      },
      {
    "fieldPath": "providerName"
      },
      {
    "fieldPath": "policyName"
      },
       {
    "fieldPath": "policyNumber"
      },
       {
    "fieldPath": "policyAddress"
      },
       {
    "fieldPath": "agentName"
      },
       {
    "fieldPath": "agentPhone"
      }, 
      
      {
      "fieldPath": "vehicleList"
      }
  ]
    
},
      "from": [
        {
          "collectionId": 'policies'
        }
      ],
      "where": {
         
            
              "fieldFilter": {
                "field": {
                  "fieldPath": 'userId'
                },
                "op": 'EQUAL',
                "value": {
                  "stringValue": userId
                }
              }
            
          ,
        
      }
    }
  }
}

  const policyQuerySchema = function(policyId){return {
    "structuredQuery":
    {
    "select":
    {
"fields": [
      {
    "fieldPath": "providerName"
      },
      {
    "fieldPath": "policyName"
      },
       {
    "fieldPath": "policyNumber"
      },
       {
    "fieldPath": "policyAddress"
      },
       {
    "fieldPath": "agentName"
      },
       {
    "fieldPath": "agentPhone"
      }, 
      {
      "fieldPath": "vinNumber"
      },
      {
    "fieldPath": "licensePlateNumber"
      }, 
      {
      "fieldPath": "vehicleList"
      }
  ]
    
},
      "from": [
        {
          "collectionId": 'policies'
        }
      ],
      "where": {
         
            
              "fieldFilter": {
                "field": {
                  "fieldPath": 'policyId'
                },
                "op": 'EQUAL',
                "value": {
                  "stringValue": policyId
                }
              }
            
          ,
        
      }
    }
  }
}


const accidentQuerySchema = function(accidentId){return{
  "structuredQuery":
  {
  "select":
  {
"fields": [
    {
  "fieldPath": "accidentClaimStatus"
    },
    {
  "fieldPath": "accidentName"
    },
     {
  "fieldPath": "accidentDate"
    },
     {
  "fieldPath": "accidentId"
    },
     {
  "fieldPath": "accidentLocation"
    },
     {
  "fieldPath": "accidentServicesRequested"
    }, 
    {
    "fieldPath": "accidentTime"
    },
    {
  "fieldPath": "accidentType"
    }, 
    {
    "fieldPath": "additionalAccidentInformation"
    },
  {
    "fieldPath" : "vehicleMake"
  },
  {
    "fieldPath" : "vehicleModel"
  },
  {
    "fieldPath" : "vehicleSpeed"
  },
  {
    "fieldPath" : "vehicleYear"
  },
  {
    "fieldPath" : "timeSubmitted"
  },
  {
    "fieldPath" : "policyId"
  },
   {
    "fieldPath" : "filesUploaded"
  }
]
  
},
    "from": [
      {
        "collectionId": 'accidents'
      }
    ],
    "where": {
       
          
            "fieldFilter": {
              "field": {
                "fieldPath": 'accidentId'
              },
              "op": 'EQUAL',
              "value": {
                "stringValue": accidentId
              }
            }
          
        ,
      
    }
  }
}}

const updateAccidentDocumentSchema = function(accidentTypeSelect, accidentName, timeValue, dateValue, vehicleSpeedValue, accidentLocation,
  makeValue,modelValue, yearValue, additionalInfoTextArea, dbArrValues){
  return {
fields: {"accidentType":
{"stringValue": accidentTypeSelect},
"accidentName":
{"stringValue": accidentName},
"accidentTime":
{"stringValue": timeValue},
"accidentDate":
{"stringValue": dateValue},
"vehicleSpeed":
{"stringValue": vehicleSpeedValue},
"accidentLocation":
{"stringValue": accidentLocation},
"vehicleMake":
{"stringValue": makeValue},
"vehicleModel":
{"stringValue": modelValue},
"vehicleYear":
{"stringValue": yearValue},
"additionalAccidentInformation":
{"stringValue": additionalInfoTextArea},

"accidentClaimStatus":
{"stringValue": 'INITIATED'},

"accidentServicesRequested":
{"arrayValue":{ "values": dbArrValues}}
},


}
}

const addAccidentDocumentSchema = function(accidentTypeSelect, accidentName, timeValue, dateValue, vehicleSpeedValue, accidentLocation,
  makeValue,modelValue, yearValue, additionalInfoTextArea, userId,timeSubmitted, accidentId, dbArrValues){
  return {
fields: {"accidentType":
{"stringValue": accidentTypeSelect},
"accidentName":
{"stringValue": accidentName},
"accidentTime":
{"stringValue": timeValue},
"accidentDate":
{"stringValue": dateValue},
"vehicleSpeed":
{"stringValue": vehicleSpeedValue},
"accidentLocation":
{"stringValue": accidentLocation},
"vehicleMake":
{"stringValue": makeValue},
"vehicleModel":
{"stringValue": modelValue},
"vehicleYear":
{"stringValue": yearValue},
"additionalAccidentInformation":
{"stringValue": additionalInfoTextArea},
"userId":
{"stringValue": userId},
"accidentClaimStatus":
{"stringValue": 'INITIATED'},
"timeSubmitted":
{"stringValue": timeSubmitted},
"accidentId":
{"stringValue": accidentId},
"policyId":
{"stringValue": 'placeholder for now'},
"accidentServicesRequested":
{"arrayValue":{ "values": dbArrValues}}
},


}
}

const updateUserDocumentSchema = function(firstName, lastName, phone, email, zipcode, city, state ){

  return {
    "fields" : {"firstName":
  {"stringValue": firstName},
  "lastName":
  {"stringValue": lastName},
  "phone":
  {"stringValue": phone},
  "email":
  {"stringValue": email},
  "zipcode":
  {"stringValue": zipcode},
  "city":
  {"stringValue": city},
  "state":
  {"stringValue": state}
    }
}

}
const accidentListQuerySchema = function(userId){
  return{
    "structuredQuery":
    {
    "select":
    {
  "fields": [
      {
    "fieldPath": "accidentClaimStatus"
      },
      {
    "fieldPath": "accidentName"
      },
       {
    "fieldPath": "accidentDate"
      },
       {
    "fieldPath": "accidentId"
      },
       {
    "fieldPath": "accidentLocation"
      },
       {
    "fieldPath": "accidentServicesRequested"
      }, 
      {
      "fieldPath": "accidentTime"
      },
      {
    "fieldPath": "accidentType"
      }, 
      {
      "fieldPath": "additionalAccidentInformation"
      },
    {
      "fieldPath" : "vehicleMake"
    },
    {
      "fieldPath" : "vehicleModel"
    },
    {
      "fieldPath" : "vehicleSpeed"
    },
    {
      "fieldPath" : "vehicleYear"
    },
    {
      "fieldPath" : "timeSubmitted"
    },
    {
      "fieldPath" : "policyId"
    }
  ]
    
},
      "from": [
        {
          "collectionId": 'accidents'
        }
      ],
      "where": {
         
            
              "fieldFilter": {
                "field": {
                  "fieldPath": 'userId'
                },
                "op": 'EQUAL',
                "value": {
                  "stringValue": userId
                }
              }
            
          ,
        
      }
    }
  }}

  module.exports = {updateUserDocumentSchema, addUserDocumentSchema, userbyAccountIdQuerySchema, userQuerySchema, policyListQuerySchema, addPolicyDocumentSchema, policyQuerySchema, addAccidentDocumentSchema, accidentQuerySchema, accidentListQuerySchema, updatePolicyDocumentSchema, updateAccidentDocumentSchema}


// WEBPACK FOOTER //
// ./src/services/database/models.js